export default "__VITE_ASSET__CRWbvxdQ__"